import { damageControlApi, reportDamageControlFailure } from "@/api/damageControl";

// Общее перечитывание осмотра для контролов разбора кадра. Имена состояния сохраняют публичные привязки
// компонентов и задаются опцией компонента `reviewRefresh: { busyKey, refreshKey, extraBusyKey }`;
// свою обработку свежего осмотра компонент даёт методом applyRefreshedInspection(inspection).
// Объект, а не фабрика: гард danglingComponentMethods разбирает миксины статически.
const config = (vm) => ({ busyKey: "busy", refreshKey: "refreshRequired", extraBusyKey: null, ...(vm.$options.reviewRefresh || {}) });

export default {
  data() {
    const { busyKey, refreshKey } = config(this);
    return { [busyKey]: false, [refreshKey]: false, errorText: "" };
  },
  created() {
    const { busyKey, refreshKey, extraBusyKey } = config(this);
    [busyKey, refreshKey, extraBusyKey].filter(Boolean).forEach(key => this.$watch(key, () => this.emitBusy()));
  },
  methods: {
    emitBusy() {
      const { busyKey, refreshKey, extraBusyKey } = config(this);
      this.$emit("busy", this[busyKey] || this[refreshKey] || Boolean(extraBusyKey && this[extraBusyKey] !== null));
    },
    async reload() {
      const inspection = await damageControlApi.getInspection(this.axios, this.inspection.id);
      if (typeof this.applyRefreshedInspection === "function") this.applyRefreshedInspection(inspection);
      else {
        this.$emit("update:inspection", inspection);
        this[config(this).refreshKey] = false;
      }
    },
    async refresh({ force = false, clearBefore = false, retryOnError = false } = {}) {
      const { busyKey, refreshKey } = config(this);
      if (!force && this[busyKey]) return;
      this[busyKey] = true;
      if (clearBefore) this.errorText = "";
      try { await this.reload(); if (!clearBefore) this.errorText = ""; }
      catch (error) {
        if (retryOnError) this[refreshKey] = true;
        this.errorText = reportDamageControlFailure(this, error, { silent: true }) ||
          (retryOnError ? this.$t("damage_control.review.update_failed") : "");
      } finally { this[busyKey] = false; }
    },
  },
};
